// src/pages/EntrepreneurshipEducationContent/CertificationsContentPage.js
import React, { useState, useEffect } from 'react';
// Import your custom CSS file. Adjust path if necessary.
// e.g., if this file is in src/pages/EEC/ and CertificationsContent.css is in src/styles/
// import '../../../styles/CertificationsContent.css'; 
import '../../styles/CertificationsContentPages.css'; // Assuming CSS is in src/styles/

import CertificateTable from './CertificateTable'; // Assuming this component exists
import AddCertificateModal from './AddCertificateModal'; // Assuming this component exists

const certificationTypes = ['Stepps Certificates', 'Short Courses', 'NQF Certificates', 'EDGENE Certificates'];

function CertificationsContentPage({ currentScope, navigateToDashboardView }) {
  const [activeCertType, setActiveCertType] = useState(certificationTypes[0]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  
  // Sample data, as in your provided component
  const [certificates, setCertificates] = useState([
    { name: 'Stepps Certificate', issuer: 'Stepps.co.za', monthYear: 'January/2025', link: 'google.drive.link', lessons: '-MS Office, -Leadership' },
    { name: 'Stepps Certificate', issuer: 'Stepps.co.za', monthYear: 'February/2025', link: 'Issued.link', lessons: '-Customer Service' },
    { name: 'Stepps Certificate', issuer: 'Stepps.co.za', monthYear: 'April/2025', link: 'Issued.link', lessons: '-Teaching' },
  ]);

  // TODO: Filter 'certificates' based on 'activeCertType' and 'currentScope'
  // For now, it shows all sample certificates regardless of activeCertType.
  // Example of how you might filter:
  // const [displayedCertificates, setDisplayedCertificates] = useState([]);
  // useEffect(() => {
  //   const filtered = certificates.filter(cert => {
  //     // Assuming your certificate objects might have a 'type' property
  //     // and you'd filter by currentScope if certificates are scope-specific
  //     return cert.type === activeCertType; // Add scope filtering if applicable
  //   });
  //   setDisplayedCertificates(filtered);
  // }, [activeCertType, currentScope, certificates]);


  useEffect(() => {
    // If currentScope changes, you might want to reset activeCertType or refetch data
    setActiveCertType(certificationTypes[0]); // Default to first type when scope changes
  }, [currentScope]);

  const handleCertTypeClick = (type) => {
    setActiveCertType(type);
    console.log(`Viewing certificate type: ${type} for scope: ${currentScope}`);
    // Here you would typically fetch or filter certificates for the selected type and scope
  };

  const openAddModal = () => setIsAddModalOpen(true);
  const closeAddModal = () => setIsAddModalOpen(false);

  const handleAddCertificate = (newCertificate) => {
    // Add the new certificate to the list, possibly with type and scope context
    setCertificates(prevCerts => [...prevCerts, { ...newCertificate, type: activeCertType, scope: currentScope }]);
    closeAddModal();
    console.log('New certificate added:', { ...newCertificate, type: activeCertType, scope: currentScope });
    // In a real application, you would send this data to an API
  };

  return (
    // Root element uses class from CertificationsContent.css
    <div className="certifications-content-page">
      {/* Breadcrumb: Wrapper uses Tailwind for general box styling, links use custom CSS */}
      <div className="breadcrumb bg-white p-3 rounded-lg shadow-sm border border-gray-200"> {/* Tailwind for wrapper */}
        <button 
            className="breadcrumb-link" // Styled by CertificationsContent.css
            onClick={() => navigateToDashboardView('functionalCardOverview', currentScope)}
        >
          {currentScope} Menu
        </button>
        <span>&gt;</span> {/* Styled by CertificationsContent.css */}
        <span className="active-breadcrumb"> {/* Styled by CertificationsContent.css */}
          Certifications ({activeCertType})
        </span>
      </div>

      {/* Content area uses class from CertificationsContent.css */}
      <div className="content-area">
        {/* Sidebar uses class from CertificationsContent.css */}
        <div className="certifications-sidebar">
          <h3 className="sidebar-title">CERTIFICATIONS</h3> {/* Styled by CertificationsContent.css */}
          {certificationTypes.map(type => (
            <button
              key={type}
              // Uses cert-button and active classes from CertificationsContent.css
              className={`cert-button ${activeCertType === type ? 'active' : ''}`}
              onClick={() => handleCertTypeClick(type)}
            >
              {type}
            </button>
          ))}
        </div>

        {/* Main content uses class from CertificationsContent.css */}
        <div className="certifications-main-content">
          <h4 className="text-lg font-semibold text-gray-700 mb-4"> {/* Added a title for the current view */}
            {activeCertType} - {currentScope}
          </h4>
          {/* Pass the (potentially filtered) certificates to CertificateTable */}
          <CertificateTable certificates={certificates} /> 
          <button className="add-certificate-button" onClick={openAddModal}>
            Add Certificate
            <span className="plus-icon">{isAddModalOpen ? '−' : '+'}</span>
          </button>
        </div>
      </div>

      {isAddModalOpen && (
        <AddCertificateModal
          onClose={closeAddModal}
          onAdd={handleAddCertificate}
        />
      )}
    </div>
  );
}

export default CertificationsContentPage;
